import {isPlatformBrowser} from '@angular/common';
import {Component, inject, OnInit, PLATFORM_ID, effect, signal} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {MsalService} from '@azure/msal-angular';
import {filter} from 'rxjs';
import {map} from 'rxjs/operators';
import {HeaderService} from '../../../../core/services/commons/header.service';
import {LayoutService} from '../../../../core/services/commons/layout.service';
import {BreadcrumbComponent} from '../breadcrumb/breadcrumb.component';
import {Tooltip} from "primeng/tooltip";
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-header',
  imports: [BreadcrumbComponent, Tooltip],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute)
  private router = inject(Router)
  private msalService = inject(MsalService)
  public layoutService = inject(LayoutService)
  public headerService = inject(HeaderService)
  private platformId = inject(PLATFORM_ID)

  currentFlag = signal<string | undefined>(undefined);

  private routeData = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.data;
      })
    ),
    { initialValue: {} }
  );

  constructor() {

    effect(() => {
      const data = this.routeData();
      this.currentFlag.set(data ? (data as any)['flag'] : undefined);
    });
  }

  logout() {
    if (isPlatformBrowser(this.platformId)) {
      this.msalService.logout();
    }
  }

  ngOnInit() {

  }
}
